import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import ScrollToTop from "../components/layout/ScrollToTop";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import ServicePage from "../pages/services/ServicePage";
import ContactUs from "../pages/ContactUs";
import SmartSupplyChainPage from "../pages/SmartSupplyChainPage";
import ProductPage from "../pages/ProductPage";
import NotFoundPage from "../pages/NotFoundPage";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="services/:slug" element={<ServicePage />} />
          <Route path="products/:slug" element={<ProductPage />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route
            path="smart-supply-chain-page"
            element={<SmartSupplyChainPage />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
